import * as async from "async";
import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as genericModals from "genericModals";
import * as mustcache from "mustcache";

const ShelfEditView = Backbone.View.extend({
  initialize: function (options) {
    this.options = options;
    this.books = options.books;
    this.models = options.models;

    this.listenTo(
      this.models.shelves,
      "change:shelfID change:name change:description",
      this.render.bind(this)
    );

    this.render();
  },
  render: function () {
    this.model = this.models.shelves.get(this.options.shelfID);

    if (this.model && this.model.id !== "unshelved") {
      mustcache.render(
        "shelfEditView",
        {
          shelf: this.model.viewJSON(),
        },
        (html) => {
          this.$el.html(html).show();
        }
      );
    } else {
      this.$el.hide();
    }
  },
  events: {
    "click .shelfName.view": "editShelfName",
    "click .saveShelfName": "saveShelfName",

    "click .shelfDescription.view": "editShelfDescription",
    "click .saveShelfDescription": "saveShelfDescription",

    "keyup .shelfNameInput": "inputKeyup",
    "keyup .shelfDescriptionTextArea": "inputKeyup",

    'change select[name="privacySettings"]': "changePrivacySettings",

    "click .shelfDescription.view a[href]": "clickDescriptionLink",

    "click .deleteShelf": "deleteShelf",
  },

  clickDescriptionLink: function (event) {
    event.stopPropagation();
  },

  editShelfName: function () {
    // reset any other controls to view mode
    this.$(".view").show();
    this.$(".edit").hide();

    // show name edit
    this.$(".shelfName.view").hide();
    this.$(".shelfName.edit").show();
    this.$(".shelfNameInput").val(this.model.get("name")).focus();
  },
  saveShelfName: function (event) {
    event.stopPropagation();
    event.preventDefault();

    const name = this.$(".shelfNameInput").val();
    if (name.trim().length === 0) {
      alert("Please give the shelf a name first");
      return;
    }
    if (this.model.get("name") === name) {
      this.model.trigger("change:name");
    } else {
      this.model.save({ name }, { patch: true });
    }
  },

  editShelfDescription: function () {
    // reset any other controls to view mode
    this.$(".view").show();
    this.$(".edit").hide();

    // show description edit
    this.$(".shelfDescription.view").hide();
    this.$(".shelfDescription.edit").show();
    this.$(".shelfDescriptionTextArea")
      .val(this.model.get("description"))
      .focus();
  },
  saveShelfDescription: function (event) {
    event.stopPropagation();
    event.preventDefault();

    const description = this.$(".shelfDescriptionTextArea").val();

    if (this.model.get("description") === description) {
      this.model.trigger("change:description");
    } else {
      this.model.save({ description }, { patch: true });
    }
  },

  changePrivacySettings: async function (event) {
    const oldValue = this.model.getPrivacyValue();
    const newValue = event.target.value;

    const privateTexts = _.filter(this.model.get("books"), (shelfBook) => {
      const book = this.options.books.get(shelfBook.bookID);
      return !book.get("public");
    });
    const unlistedPublicTexts = _.filter(
      this.model.get("books"),
      (shelfBook) => {
        const book = this.options.books.get(shelfBook.bookID);
        return book.get("public") && book.get("hide");
      }
    );

    const cancelChange = () => {
      // Set the privacy setting back to the old value
      this.$("select[name='privacySettings']").val(oldValue);
    };

    switch (newValue) {
      case "private":
        genericModals.confirm({
          title: "Un-Share shelf?",
          message:
            "Other users will no longer be able to view this shelf. Are you sure you want to " +
            "un-share it?",
          callback: (response) => {
            if (response === "ok") {
              this.model.setPrivacyValue("private");
              this.$(".shareLink").fadeOut();
            } else {
              cancelChange();
              return;
            }
          },
        });
        break;

      case "linkOnly":
        if (
          privateTexts.length > 0 &&
          !confirm(
            "This will make " +
              privateTexts.length +
              " currently private text" +
              (privateTexts.length === 1 ? "" : "s") +
              " accessible to anyone with the link. Are you sure?"
          )
        ) {
          cancelChange();
          return;
        }
        for (const book of privateTexts) {
          await new Promise((resolve) => {
            this.options.books.get(book.bookID).addTag("shared", resolve, true);
          });
        }

        this.model.setPrivacyValue("linkOnly");
        this.$(".shareLink").fadeIn();
        break;

      case "public":
        if (
          privateTexts.length > 0 &&
          !confirm(
            "This will make " +
              privateTexts.length +
              " currently private text" +
              (privateTexts.length === 1 ? "" : "s") +
              " public. Are you sure?"
          )
        ) {
          cancelChange();
          return;
        }
        if (
          unlistedPublicTexts.length > 0 &&
          !confirm(
            "This will make " +
              unlistedPublicTexts.length +
              " text" +
              (unlistedPublicTexts.length === 1 ? "" : "s") +
              " currently only accessible via the link" +
              " accessible to everyone. Are you sure?"
          )
        ) {
          cancelChange();
          return;
        }
        for (const book of privateTexts) {
          await new Promise((resolve) => {
            this.options.books.get(book.bookID).addTag("shared", resolve);
          });
        }
        for (const book of unlistedPublicTexts) {
          await this.options.books
            .get(book.bookID)
            .save({ hide: false }, { patch: true });
        }
        this.model.setPrivacyValue("public");
        this.$(".shareLink").fadeIn();
        break;

      default:
        throw Error("Invalid privacy setting: " + newValue);
    }
  },

  publicCheckbox: function (event) {
    event.preventDefault();

    const $checkbox = $(event.target);

    const isPublic = $checkbox.is(":checked");
    if (isPublic) {
      let privateTexts;

      async.series(
        [
          (callback) => {
            privateTexts = _.filter(this.model.get("books"), (shelfBook) => {
              const book = this.options.books.get(shelfBook.bookID);
              return !book.get("public");
            });

            if (privateTexts.length === 0) {
              callback();
            } else if (
              confirm(
                "This will make " +
                  privateTexts.length +
                  " currently private text" +
                  (privateTexts.length === 1 ? "" : "s") +
                  " public. Are you sure?"
              )
            ) {
              callback();
            } else {
              // @ts-ignore
              callback("Cancel due to private texts");
            }
          },
          (callback) => {
            // share all private texts...
            async.each(
              privateTexts,
              (book, innerCallback) => {
                this.options.books
                  .get(book.bookID)
                  .addTag("shared", innerCallback);
              },
              callback
            );
          },
        ],
        (error) => {
          if (error) {
            return;
          }

          this.model.save({ public: true }, { patch: true });
          this.$(".shareLink").fadeIn();
          $checkbox.prop("checked", true);
        }
      );
    } else {
      genericModals.confirm({
        title: "Un-Share shelf?",
        message:
          "Other users will no longer be able to view this shelf. Are you sure you want to un-share it?",
        callback: (response) => {
          if (response === "ok") {
            this.model.save({ public: false }, { patch: true });
            this.$(".shareLink").fadeOut();

            $checkbox.prop("checked", false);
          }
        },
      });
    }
  },

  inputKeyup: function (event) {
    if (event.which === 27 /* ESCAPE key */) {
      // cancel edit
      this.render();
    }
  },

  deleteShelf: function () {
    genericModals.confirm({
      title: "Delete Shelf",
      message:
        "Are you sure you want to delete this shelf?\n\n" +
        "This cannot be undone!\n\n" +
        "(None of the actual texts will be deleted)",
      callback: (response) => {
        if (response === "ok") {
          this.model.save(
            { deleted: true },
            {
              patch: true,
              success: () => {
                this.models.shelves.setSelectedShelfID(null);
                this.options.appRouter.navigate("/myTexts/queue", {
                  trigger: true,
                });
              },
            }
          );
        }
      },
    });
  },
});

export default ShelfEditView;
